import React from 'react';
import bollywoodtalent from '../../assets/bollywoodtalent.jpg';
import './philosophy.css';

const Philosophy = () => {
  return (
    <section className="philosophy section__padding">
      <div className="philosophy__container">
        <div className="philosophy__content">
          <h2 className="gradient__text philosophy__title">Our Philosophy</h2>
          
          <p className="philosophy__intro">
            We bring forth new and aspiring musicians and singers in North America
          </p>

          <div className="philosophy__text">
            <p>
              Conceptualized by Rajan Sharma, a CPA by profession, Bollywood Ki Dhun enables people from the South Asian community residing in North America to showcase their talents. He moved to Canada in December 1981.
            </p>

            <blockquote className="philosophy__quote">
              "Music has always had a special place in my heart. However, back in the day, there weren't many platforms and mediums as there are now for people to showcase their talent to the world. Through Bollywood Ki Dhun, I want to encourage people who have an interest in singing or playing musical instruments to pursue their passion and provide them with a stage where they can perform."
              <span>— Rajan Sharma, Founder, Bollywood Ki Dhun</span>
            </blockquote>

            <p>
              We explore new talent among South Asians, including people from India, Bangladesh, Sri Lanka, Pakistan, Afghanistan, Bhutan, Nepal, and the Maldives. We scout talents by mainly reaching out to organizations and through word-of-mouth promotions.
            </p>
          </div>
        </div>

        <div className="philosophy__image">
          <img src={bollywoodtalent} alt="Bollywood Ki Dhun philosophy and founder vision" />
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
